import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import SearchIcon from "assets/svgIcons/SearchIcon";
import { CalanderWrapper } from "assets/css/globle.js";
import { SelectTagCar, HistoryWrapper } from "./MapStyled";
import {
  COMMON_SERVICES
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import {
  MAP_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import moment from "moment/moment";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CloseIcon from "../../../../assets/svgIcons/CloseIcon";
import { useTranslation } from "react-i18next";
import { isUserAdmin, userRoles } from "../../../../constant";

export const HistorySection = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { loadingOnProcess, historyNoDataPopup } =
    useHookstate(MAP_GLOBAL_STATES);

  const historyOptionsList = [
    {
      name: t("History"),
      value: 1,
    },
    {
      name: t("Cellular_Xmit_State"),
      value: 2,
    },
    {
      name: t("GPS_Quality"),
      value: 3,
    },
    {
      name: t("Wi-Fi_Signal"),
      value: 4,
    },
  ];
  
  let tempDate = new Date();
  let carHistoryDate = localStorage.getItem("carHistoryDate");

  if (carHistoryDate) tempDate = new Date(carHistoryDate);

  const {
    specificCarHistory,
    carHistoryList,
    historyOptions,
    mapSideNavTabState,
    specificHistoryClicked
  } = useHookstate(MAP_GLOBAL_STATES);
  
  const [value, setValue] = useState(tempDate);
  const [searchInput, setSearchInput] = useState("");
  const [closeHistorySection, setCloseHistorySection] = useState(true);
  const [highlightCar, setHighlightCar] = useState([]);
  const [activeButton, setActiveButton] = useState(false);
  const [allButton, setAllButton] = useState(true);
  const [noneButton, setNoneButton] = useState(false);
  const [startDate, endDate] = useState([null, null]);
  const [historyOption, setHistoryOption] = useState(historyOptions.get());

  const dispatch = useDispatch();

  const { carHistoryData } = useSelector((state) => state.commonReducers) || [];

  const { specificCarHistoryData, specificCarHistoryStatus, getUserRole } = useSelector((state) => state.commonReducers) || [];

  useEffect(() => {
    let prevHistoryOption = localStorage.getItem("historyOption");
    if (prevHistoryOption) setHistoryOption(prevHistoryOption);
  }, []);

  useEffect(() => {
    if (siteId.get()) {
      setActiveButton(false);

      // it will set siteId for getCarHistoryServices api
      localStorage.setItem("recentSite", siteId.get());

      let carHistoryDate = localStorage.getItem("carHistoryDate");
      if (carHistoryDate) {
        setValue(new Date(carHistoryDate));
        dispatch(COMMON_SERVICES.getCarHistoryServices(moment(new Date(carHistoryDate)).format("YYYY-MM-DD"), siteId.get()));
      } else {
        dispatch(COMMON_SERVICES.getCarHistoryServices(moment(new Date()).format("YYYY-MM-DD"), siteId.get()));
      }
    }
  }, [siteId.get()]);

  useEffect(() => {
    if (specificCarHistoryStatus === "success") {
      // if user has selected car and data of few cars are avialable
      if (Object.keys(specificCarHistoryData).length) {
        specificCarHistory.set(true);

        if (carHistoryList.get().length) {
          let array = [];

          // here those cars number is active whose data is displayed in map
          carHistoryList.get().forEach((value) => {
            if (Object.keys(specificCarHistoryData).includes(value.toString())) {
              array.push(value);
            }
          });
          setHighlightCar(array);
        } else {
          // setting data of all cars here
          setHighlightCar([...Object.keys(specificCarHistoryData)]);
        }
      } else {
        specificCarHistory.set(false);
        if (carHistoryList.get().length !== 0) {
          historyNoDataPopup.set(true);
        }
      }
    }
  }, [specificCarHistoryStatus]);

  useEffect(() => {
    if (!historyNoDataPopup.get()) {
      carHistoryList.set([]);
      setHighlightCar([]);
      setAllButton(false);
      setNoneButton(true);
    }
  }, [historyNoDataPopup.get()]);

  useEffect(() => {
    handleCarHistoryData();
  }, [carHistoryData]);

  useEffect(() => {
    if(specificHistoryClicked.get() != null && specificHistoryClicked.get()) {
      getHistory();
      specificHistoryClicked.set(false);
    }
  }, [specificHistoryClicked.get()]);

  const getDate = (dateDate) => {
    setActiveButton(false);
    setHighlightCar([]);
    carHistoryList.set([]);
    setAllButton(false);
    setNoneButton(true);
    setValue(dateDate);
    localStorage.setItem("carHistoryDate", dateDate.toString());
    if (dateDate) {
      loadingOnProcess.set(true);
      dispatch(COMMON_SERVICES.getCarHistoryServices(moment(new Date(dateDate)).format("YYYY-MM-DD"), siteId.get())).then(() => {
        loadingOnProcess.set(false);
      });
    }
  }

  const selectCars = (itemData) => {
    setActiveButton(true);
    const exist = highlightCar.find((item) => item === itemData);
    
    if (exist) {
      let newData = highlightCar.filter((item) => item !== itemData);
      setHighlightCar(newData);
      
      // Setting state of highlight car and then setting state of global state related to car history
      carHistoryList.set(newData);

      localStorage.removeItem("historySelectedCar");
    } else {
      setHighlightCar([...highlightCar, itemData]);
      carHistoryList.set([...carHistoryList.get(), itemData]);

      localStorage.setItem("historySelectedCar", itemData);
    }  
    
    handleAllNoneButtons();
  }

  const handleAllNoneButtons = () => {
    if(carHistoryData?.length > 0){
      const userAdmin = isUserAdmin(getUserRole && getUserRole?.Role);
      const filteredCarDataHistory = userAdmin ? carHistoryData : carHistoryData.filter(x => x >= 0)

      if(filteredCarDataHistory?.length === carHistoryList?.get()?.length){
        setAllButton(true);
        setNoneButton(false);
      }
      else if(carHistoryList?.get()?.length > 0 && filteredCarDataHistory?.length !== carHistoryList?.get()?.length){
        setAllButton(false);
        setNoneButton(false);
      }
      else{
        setAllButton(false);
        setNoneButton(true);
      }
    }
  }

  const resetFunction = () => {
    setActiveButton(false);
    setHighlightCar([]);
    getDate(new Date());
    carHistoryList.set([]);   
    setSearchInput("");
    setAllButton(false);
    setNoneButton(false);
    getHistory();
  }

  const refreshFUnction = () => {
    getDate(value);
  }

  const getHistory = async () => {
    loadingOnProcess.set(true);
    dispatch(
      COMMON_SERVICES.getSpecificCarHistoryServices(
        carHistoryList.get(),
        moment(value).format("YYYY-MM-DD"),
        siteId.get()
      )
    ).then(() => {
      setActiveButton(false);
    });

    if (window.innerWidth < 850) mapSideNavTabState.set("");
  }

  const handleAll = (selectionType) => {
    if (selectionType === "all") {
      handleCarHistoryData();
    } else if (selectionType === "none") {
      carHistoryList.set([]);
      setHighlightCar([]);
    }

    setAllButton(selectionType === "all");
    setNoneButton(selectionType === "none");
  }

  const handleCarHistoryData = () => {
    const admin = isUserAdmin(getUserRole && getUserRole?.Role);

    const all = carHistoryData?.length > 0 && carHistoryData?.filter((item) => {
        if (searchInput === "" && (admin || !admin && item >= 0)) {
          return item;
        } else if (item.toString().toLowerCase().includes(searchInput.toLowerCase()) && (admin || !admin && item >= 0)) {         
          return item;
        }
      });

    const carNumberData = all && all.map((item) => item);

    if (all && all.length !== 0) {
      carHistoryList.set(carNumberData);
      setHighlightCar(carNumberData);

      setActiveButton(true);
    }

    handleAllNoneButtons();
  }

  return (
    <HistoryWrapper>
      {closeHistorySection && (
        <>
          <div className="close-icon-wrapper-mobile">
            <button
              onClick={() => {
                setCloseHistorySection(!closeHistorySection);
                mapSideNavTabState.set("");
              }}
            >
              <CloseIcon />
            </button>
          </div>
          {getUserRole && (getUserRole.Role == userRoles.admin || getUserRole.Role == userRoles.support) && (
            <FormControl sx={{ m: 1, minWidth: 250 }}>
              <Select
                value={historyOption}
                onChange={(e) => {
                  setHistoryOption(e.target.value);
                  historyOptions.set(e.target.value);
                  localStorage.setItem("historyOption", e.target.value);
                }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                {historyOptionsList.map(({ name, value }) => (
                  <MenuItem
                    sx={{ background: "var(--admin-tab-bg)" }}
                    key={value}
                    value={value}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {/* </FormControl> */}
          <CalanderWrapper>
            <Calendar
              startDate={startDate}
              endDate={endDate}
              onChange={getDate}
              value={value}
              formatShortWeekday={(locale, value) =>
                ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][value.getDay()]
              }
            />
          </CalanderWrapper>
          <SelectTagCar className="white-theme history-tag-cars">
            <div className="inner-wrapper">
              <div className="search-wrapper">
                <input
                  placeholder={t("Search_car_no")}
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <SearchIcon color="#636F7C" />
              </div>

              <div className="car-selection">
                <div className="action-wrapper">
                  <div>
                    <button className={allButton ? "active" : ""} onClick={() => handleAll("all")}>{t("All")}</button>
                    <span style={{margin: "5px"}}>|</span> 
                    <button className={noneButton ? "active" : ""} onClick={() => handleAll("none")}>{t("None")}</button></div>
                </div>
                
                <div className="car-number">
                  {carHistoryData?.length > 0 ? (
                    carHistoryData
                      .filter((item) => {
                        if (searchInput === "" && (isUserAdmin(getUserRole && getUserRole?.Role) || !isUserAdmin(getUserRole && getUserRole?.Role) && item >= 0)) {
                          return item;
                        } else if (
                          item.toString()
                            .toLowerCase()
                            .includes(searchInput.toLowerCase()) &&
                            (isUserAdmin(getUserRole && getUserRole?.Role) || !isUserAdmin(getUserRole && getUserRole?.Role) && item >= 0)
                        ) {
                          return item;
                        }
                      })
                      .sort((a, b) => a.Car - b.Car)
                      .map((item, index) => (
                        <button
                          key={index}
                          className={
                            highlightCar?.length > 0
                              ? highlightCar.find((item2) => item2 === item)
                                ? "active"
                                : ""
                              : ""
                          }
                          onClick={() => {
                            selectCars(item);
                          }}
                        >
                          {item}
                        </button>
                      ))
                  ) : (
                    <p style={{ textAlign: "center", width: "100%" }}>
                      {t("No_data")}
                    </p>
                  )}
                </div>
                <div className="reset-section">
                  <div className="action-wrapper">
                    <button
                      className={activeButton ? "active" : "disabled"}
                      disabled={!activeButton}
                      onClick={() => getHistory("ok")}
                    >
                      {t("Ok")}
                    </button>
                    <button onClick={() => refreshFUnction("refresh")}>
                      {t("Refresh")}
                    </button>
                    <button
                      className="send-btn"
                      onClick={() => resetFunction("reset")}
                    >
                      {t("Reset")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </SelectTagCar>{" "}
        </>
      )}
    </HistoryWrapper>
  );
};
